<script setup>
import { computed, ref } from "vue";
import { mdiEye, mdiTrashCan, mdiPencil, mdiCheckCircle, mdiCloseCircle, mdiPlusCircle, mdiSearchWeb, mdiLanguageHtml5, mdiRefresh } from "@mdi/js";// LRR https://materialdesignicons.com/
import BaseIcon from "@/Components/BaseIcon.vue";
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BaseLevel from "@/Components/BaseLevel.vue";
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import { Inertia } from '@inertiajs/inertia';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
import BreezeInput from '@/Components/Input.vue';
import BreezeSelect from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import { isIntegerKey } from "@vue/shared";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
//import mavonEditor from 'mavon-editor';
//import Editor from '@/Components/Editor.vue';
import { QuillEditor } from '@vueup/vue-quill'
import BlotFormatter from 'quill-blot-formatter'

import { isError } from "util";
//import { isConfirmed } from "@/Components/CardBoxModal.vue";
const props = defineProps({
	data: Array,
	isRef: Boolean,
	checkable: Boolean,
	updateable: Boolean,
	visualable: Boolean,
	deleteable: Boolean,
	isModalDeleteActive: Boolean,
	ruta: String,
	modulo: String,
	select1: Array,
	select2: Array,
	select3: Array,
	src_id: Number,
	nostatus: Boolean,
	nosearchable: Boolean,
	noupdate: Boolean,
	nocreate: Boolean,
	showRefresh: Boolean,
	actionRefresh: Array,
	originType: String,
	isCoord: Boolean,
	param: Object,
	debugInertia: Boolean,
	tableclass: {
		default: 'table-responsive'
	}
});

//console.log(props.select1)
//console.log(props.select2)

const modulesEditor = {
	name: 'blotFormatter',
	module: BlotFormatter,
	options: {/* options */ }
}

//const emit = defineEmits(["reload"]); // Volver a cargar data para usar axios

const title = ref(props.modulo)
if (props.modulo == 'collaborator-classroom' || props.modulo == 'collaborator-coord-classroom') {
	title.value = 'aula'
} else if (props.modulo == 'collaborator-course') {
	title.value = 'curso'
} else if (props.modulo == 'holiday') {
	title.value = 'día festivo'
} else if (props.modulo == 'collaboratorhour') {
	title.value = 'horario de asistencia'
} else if (props.modulo == 'collaboratorturn' || props.modulo == 'collaboratorturn-user') {
	title.value = 'Turno de asistencia'
}


// Set toolbar options Quill editor
const toolbarOptions = [
	['bold', 'italic', 'underline', 'strike'],
	['blockquote', 'code-block'],

	[{ 'header': 1 }, { 'header': 2 }],
	[{ 'list': 'ordered' }, { 'list': 'bullet' }],
	[{ 'script': 'sub' }, { 'script': 'super' }],
	[{ 'indent': '-1' }, { 'indent': '+1' }],
	[{ 'direction': 'rtl' }],

	[{ 'size': ['small', false, 'large', 'huge'] }],
	[{ 'header': [1, 2, 3, 4, 5, 6, false] }],

	[{ 'color': [] }, { 'background': [] }],
	[{ 'font': [] }],
	[{ 'align': [] }],
	['link', 'image', 'video'],
	['clean'],
];
// LRR Revisar
/*const confirmado = CardBoxModal.emits
if (confirmado.value == "confirm") {
  console.log('Hola')
}
console.log(confirmado)
*/
// - LRR store no definido
//const mainStore = useMainStore();
//const items = computed(() => mainStore.clients);
//let me = this;
/*const mainStore = {"users": [
						{"id":1,"user": "lenin", "name":"Lenin"},
						{"id":2,"user": "lucy", "name":"Lucy"},
						{"id":3,"user": "lucy", "name":"Lucy"},
						{"id":4,"user": "lucy", "name":"Lucy"},
						{"id":5,"user": "lucy", "name":"Lucy"},
						{"id":6,"user": "lucy", "name":"Lucy"},
						{"id":7,"user": "lucy", "name":"Lucy"}
					]};
console.log(mainStore);
*/
//const mainStore = this.defineProps();

const rowTextArea = ref(15)
const items = computed(() => props.data);

const isModalActive = ref(false);
const showHtmlText = ref(false);

const isModalDangerActive = ref(false);
const perPage = ref(25);// cantidad de registros por página

const currentPage = ref(0);

const checkedRows = ref([]);

const itemsPaginated = computed(() =>
	items.value.slice(
		perPage.value * currentPage.value,
		perPage.value * (currentPage.value + 1)
	)
);

const numPages = computed(() => Math.ceil(items.value.length / perPage.value));

const currentPageHuman = computed(() => currentPage.value + 1);
const pagesList = computed(() => {
	const pagesList = [];

	for (let i = 0; i < numPages.value; i++) {
		pagesList.push(i);
	}

	return pagesList;
});
const remove = (arr, cb) => {
	const newArr = [];

	arr.forEach((item) => {
		if (!cb(item)) {
			newArr.push(item);
		}
	});

	return newArr;
};
const checked = (isChecked, client) => {
	if (isChecked) {
		checkedRows.value.push(client);
	} else {
		checkedRows.value = remove(
			checkedRows.value,
			(row) => row.id === client.id
		);
	}
};

// LRR
//var isModalDeleteActive = isModalDangerActive;

/*const mostrarId = (id) => {
	  //isModalAlertActive = true;
	  alert('Hola '+id);
};
*/
/*const app = createApp({
  data() {
	return {
	  isModalDeleteActive: false,

	}

  },
  methods : {
	desactivar (id) {
	  let me = this;
	  me.isModalDeleteActive = true
	  alert('Hola '+id+'modal es '+isModalDeleteActive);
	}
  }
})
*/

// LRR
//const emit = defineEmits(["listar"]);
const titleModal = ref('')
const isErrorForm = ref(false)
const rowID = ref(0);
const rowPivot1 = ref(0);
const rowPivot2 = ref(0);
const rowAction = ref('action');
const rowLabel = ref('');
const form = useForm({
	ref: '',
	label: '',
	secondary_label: '',
	label_short: null,
	short_label: null,
	parent: null,
	position: 0,
	id_institution: null,
	id_level: null,
	id_course_area: null,
	anio: '',
	anio_fin: '',
	asunto: '',
	type: '',
	description: '',
	note: null,
	resolution: '',
	address: '',
	id_course: null,
	id_classroom: null,
	nivel: '',
	tutor: (!props.isCoord ? 0 : 1), //<-- Si es coord marcado por defecto
	name: '',
	visible: 0,
	admin: 0,
	value: '',
	ciclo_curricular: '',
	ciclos: '',
	entity: 0,
	id_modular_code: 0,
	transkey: '',
	transvalue: '',
	id_collaborator: 0,
	id_collaboratorturn: 0,
	day: '01',
	month: '01',
	year: 0,
	hora_entrada: '',
	hora_salida: '',
	tolerancia_tarde: '',
	hour_rest: '',
	id_hour_monday: 0,
	id_hour_tuesday: 0,
	id_hour_wednesday: 0,
	id_hour_thursday: 0,
	id_hour_friday: 0,
	id_hour_saturday: 0,
	id_hour_sunday: 0,
	url: '',
	target: 1,
	color: 'red'

});
//const selectFilter = [
//{ id: 1, column: 'label', label: "Descripción" },
//{ id: 2, label: "Marketing" },
//{ id: 3, label: "Sales" },
//];
const selectCriterio = ref('label');
const buscarCriterio = ref('');

const listar = (criterio, buscar) => {
	let ruta = 'config-' + props.ruta// + '?criterio=' + criterio + '&buscar=' + buscar
	if (props.modulo == 'collaborator-course') {
		ruta = 'listar-' + props.ruta
	} else if (props.modulo == 'collaborator-course') {
		ruta = 'listar-' + props.ruta
	} else if (props.originType == 'opciones-avanzadas') {// <-- Modificar destino de búsqueda
		ruta = 'constante-edit'
	}

	let params = {
		'criterio': criterio,
		'buscar': buscar
	}

	// Agregar parámetro estático si existe por ejemplo en aula es type 0 o 1
	if (props.param) {
		if (props.param.hasOwnProperty("paramstatic1")) {
			if (props.param.paramstatic1) {
				params.paramstatic1 = props.param.paramstatic1
			}
		}
	}

	Inertia.get(route(ruta, params))

	/* if(props.param) {
	  Object.assign(params, props.param) // <-- Agregar más propiedades al objeto, en este caso más parámetros
	  console.log(params)
	} */

	//buscarCriterio.value = ''
	//}
}

// Recuperar valores de búsqueda
if (props.param) {
	if (props.param.hasOwnProperty("criterio")) {
		if (props.param.criterio) {
			selectCriterio.value = props.param.criterio
		}
	}

	if (props.param.hasOwnProperty("buscar")) {
		if (props.param.buscar) {
			buscarCriterio.value = props.param.buscar
		}
	}

}


const initModal = (id, action, data = []) => {
	isErrorForm.value = false
	rowAction.value = action
	if (action == 'registrar') {
		titleModal.value = 'Registrar'
	} else if (action == 'actualizar') {
		titleModal.value = 'Actualizar'
	}

	if (action == 'registrar') {
		isModalActive.value = true
		if (props.modulo == 'Aula') {
			if (props.param && props.param.hasOwnProperty("paramstatic1") && props.param.paramstatic1) {
				form.type = props.param.paramstatic1
			} else {
				form.type = 0
			}

		}

	} else if (action == 'actualizar') {
		rowID.value = id;
		isModalActive.value = true
		form.label = data['label']// <-- Todos tienen label
		if (props.isRef) form.ref = data['ref']

		if (props.modulo == 'Nivel') {
			form.ref = data['ref']
			form.label_short = data['label_short']
			form.parent = data['id_parent']
			form.position = data['position']
			form.ciclo_curricular = data['ciclo_curricular']
			form.entity = data['entity']
		} else if (props.modulo == 'Curso') {
			form.ref = data['ref']
			form.id_level = data['id_level']
			form.label_short = data['label_short']
			form.id_course_area = data['id_course_area']
			form.anio = data['anio']
			form.anio_fin = data['anio_fin']
			form.description = data['description']
		} else if (props.modulo == 'competencia') {
			form.id_course_area = data['id_course_area']
			form.ciclos = data['ciclos']
			form.description = data['description']
		} else if (props.modulo == 'ayuda') {
			form.label = data['label']
			form.type = data['type']
			form.description = data['description']
		} else if (props.modulo == 'Aula') {
			form.ref = data['ref']
			form.id_level = data['id_level']
			form.label_short = data['label_short']
			form.note = data['note']
			//form.resolution = data['resolution']
			form.type = data['type']
			form.id_modular_code = data['id_modular_code']
		} else if (props.modulo == 'constante') {
			form.name = data['name']
			form.type = data['type']
			form.value = data['value']
			form.note = data['note']
			form.visible = data['visible']
			form.position = data['position']
		} else if (props.modulo == 'modularcode') {
			form.id_institution = data['id_institution']
			form.id_level = data['id_level']
		} else if (props.modulo == 'institution') {
			form.short_label = data['short_label']
			form.resolution = data['resolution']
			form.address = data['address']
			form.note = data['note']
		} else if (props.modulo == 'Área curricular') {
			form.position = data['position']
		} else if (props.modulo == 'traductor') {
			form.id_level = data['level']
			form.transkey = data['transkey']
			form.transvalue = data['transvalue']
		} else if (props.modulo == 'holiday') {
			form.ref = data['ref']
			form.day = data['day']
			form.month = data['month']
			form.year = data['year']
		} else if (props.modulo == 'collaboratorhour') {
			form.ref = data['ref']
			form.hora_entrada = data['hora_entrada']
			form.hora_salida = data['hora_salida']
			form.tolerancia_tarde = data['tolerancia_tarde']
			form.hour_rest = data['hour_rest']
		} else if (props.modulo == 'collaboratorturn') {
			form.ref = data['ref']
			form.id_hour_monday = data['id_hour_monday']
			form.id_hour_tuesday = data['id_hour_tuesday']
			form.id_hour_wednesday = data['id_hour_wednesday']
			form.id_hour_thursday = data['id_hour_thursday']
			form.id_hour_friday = data['id_hour_friday']
			form.id_hour_saturday = data['id_hour_saturday']
			form.id_hour_sunday = data['id_hour_sunday']
		} else if (props.modulo == 'mark') {
			form.label = data['label']
			form.description = data['description']
			form.url = data['url']
			form.target = data['target']
			form.color = data['color']
			form.position = data['position']
		}

	} else {
		rowID.value = id;
		isModalDangerActive.value = true

		// Para Pivote
		if (props.modulo == 'collaborator-course') {
			rowPivot1.value = data['id_collaborator']
			rowPivot2.value = data['id_course']
		} else if (props.modulo == 'collaborator-classroom' || props.modulo == 'collaborator-coord-classroom') {
			rowPivot1.value = data['id_collaborator']
			rowPivot2.value = data['id_classroom']
		} else if (props.modulo == 'collaboratorturn-user') {
			rowPivot1.value = data['pivot']['id_collaborator']
			rowPivot2.value = data['pivot']['id_collaboratorturn']
		}
		//console.log (rowPivot1.value + ' y ' + rowPivot2.value)
	}
}
const isConfirm = () => {
	//alert('Hola '+rowID.value+'modal es '+rowAction.value)
	const ruta = props.ruta + '-' + rowAction.value
	/*axios.put(ruta, {
	  'id' : rowID.value
	}).then(function response () {
	  // Escribir algo si es ok
	  //window.location.reload()
	  //Redirect(props.ruta)
	  //redirect('config-distrito')
	  //return route('config-distrito');
  
	  //Inertia.get(route('config-distrito'))
	}).catch(function (error) {
	  console.log(error)
	})*/
	if (rowAction.value == 'registrar') {

		if (props.modulo == 'Nivel') {
			if (!form.label || !form.ref) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.post(route(ruta, {
					'label': form.label,
					'label_short': form.label_short ?? null,
					'ref': form.ref,
					'id_parent': form.parent ? form.parent : null,
					'position': form.position,
					'ciclo_curricular': form.ciclo_curricular,
					'entity': form.entity !== null ? form.entity : null
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'Curso') {
			if (!form.label || !form.id_course_area || !form.id_level || !form.anio) {// || !form.ref 
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.post(route(ruta, {
					'label': form.label,
					'label_short': form.label_short ?? null,
					'ref': form.ref,
					'id_level': form.id_level,
					'id_course_area': form.id_course_area,
					'anio': form.anio,
					'anio_fin': form.anio_fin,
					'description': form.description,
					'search_criterio': selectCriterio.value,
					'search_buscar': buscarCriterio.value
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'Área curricular') {
			if (!form.label || !form.position || !form.ref) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.post(route(ruta, {
					'label': form.label,
					'position': form.position,
					'ref': form.ref,
					'search_criterio': selectCriterio.value,
					'search_buscar': buscarCriterio.value
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'competencia') {
			if (!form.label || !form.id_course_area) {// || !form.ref 
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.post(route(ruta, {
					'label': form.label,
					'id_course_area': form.id_course_area,
					'ciclos': form.ciclos,
					'description': form.description,
					'search_criterio': selectCriterio.value,
					'search_buscar': buscarCriterio.value
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'ayuda') {
			if (!form.label || !form.description || !form.type) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.post(route(ruta, {
					'label': form.label,
					'type': form.type,
					'description': form.description,
					'search_criterio': selectCriterio.value,
					'search_buscar': buscarCriterio.value
				}
				))
				cleanVal(1, 1)// <-- Es editor y Limpiar editor
			}

		} else if (props.modulo == 'Aula') {
			if (!form.label || !form.ref || !form.id_level) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.post(route(ruta, {
					'label': form.label,
					'secondary_label': form.secondary_label ?? null,
					'label_short': form.label_short ?? null,
					'id_level': form.id_level ?? null,
					'ref': form.ref,
					'resolution': form.resolution ?? null,
					'note': form.note ?? null,
					'type': form.type,
					'id_modular_code': form.id_modular_code ?? null,
					'search_type': props.param.paramstatic1 ?? null,
					'search_criterio': selectCriterio.value,
					'search_buscar': buscarCriterio.value
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'modularcode') {
			if (!form.ref || !form.id_level || !form.id_institution) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.post(route(ruta, {
					'id_institution': form.id_institution,
					'label': form.label,
					'id_level': form.id_level,
					'ref': form.ref
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'institution') {
			if (!form.label || !form.ref || !form.short_label || !form.resolution || !form.address) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.post(route(ruta, {
					'resolution': form.resolution,
					'label': form.label,
					'short_label': form.short_label,
					'ref': form.ref,
					'address': form.address,
					'note': form.note
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'constante') {
			if (!form.name || !form.type || !form.note) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.post(route(ruta, {
					'name': form.name,
					'type': form.type,
					'note': form.note,
					'value': form.value,
					'visible': form.visible,
					'position': form.position,
					'search_criterio': selectCriterio.value,
					'search_buscar': buscarCriterio.value
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'traductor') {
			if (!form.transkey || !form.transvalue) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.post(route(ruta, {
					'id_level': form.id_level,
					'transkey': form.transkey,
					'transvalue': form.transvalue,
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'holiday') {
			if (!form.day || !form.month || !form.ref) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.post(route(ruta, {
					'ref': form.ref,
					'label': form.label,
					'day': form.day,
					'month': form.month,
					'year': form.year
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'collaboratorhour') {
			if (!form.hora_entrada || !form.hora_salida || !form.ref) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.post(route(ruta, {
					'ref': form.ref,
					'label': form.label,
					'hora_entrada': form.hora_entrada,
					'hora_salida': form.hora_salida,
					'tolerancia_tarde': form.tolerancia_tarde,
					'hour_rest': form.hour_rest
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'collaboratorturn') {
			if (!form.ref) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.post(route(ruta, {
					'ref': form.ref,
					'label': form.label,
					'id_hour_monday': form.id_hour_monday,
					'id_hour_tuesday': form.id_hour_tuesday,
					'id_hour_wednesday': form.id_hour_wednesday,
					'id_hour_thursday': form.id_hour_thursday,
					'id_hour_friday': form.id_hour_friday,
					'id_hour_saturday': form.id_hour_saturday,
					'id_hour_sunday': form.id_hour_sunday
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'mark') { // <-- table simple
			if (!form.label || !form.url) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.post(route(ruta, {
					'label': form.label,
					'description': form.description,
					'url': form.url,
					//'target' : form.target,
					'color': form.color,
					'position': form.position
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'collaboratorturn-user') { // <-- Pivotes
			if (!form.id_collaboratorturn) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.post(route(ruta, {
					'id': props.src_id, // ID de colaborador
					'id_collaboratorturn': form.id_collaboratorturn,
					'entity': (form.entity ? form.entity : 1),
				}
				))
				console.log(checkedFilters.value)
				cleanVal()
				//if (!props.debugInertia) Inertia.reload({ only: ['object']})// <-- Actualiza una propiedad en este caso el with(classrooms) que está en object
				//if (!props.debugInertia) Inertia.reload({ only: ['object'], preserveState: true})
				//Inertia.reload({ only: [props.data]})
				//router.reload({ only: ['data'] })
				//listar(selectCriterio.value, buscarCriterio.value)
			}

		} else if (props.modulo == 'collaborator-classroom') {
			if (!form.id_classroom) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.post(route(ruta, {
					'id': props.src_id, // ID de colaborador
					'id_classroom': form.id_classroom,
					'id_course': form.id_course,
					'tutor': form.tutor,
					'data_courses': checkedFilters.value
				}
				))
				console.log('Asignación de aulas con su curso')
				console.log(checkedFilters.value)
				cleanVal()
				//if (!props.debugInertia) Inertia.reload({ only: ['object']})// <-- Actualiza una propiedad en este caso el with(classrooms) que está en object
				//if (!props.debugInertia) Inertia.reload({ only: ['object'], preserveState: true})
				//Inertia.reload({ only: [props.data]})
				//router.reload({ only: ['data'] })
				//listar(selectCriterio.value, buscarCriterio.value)
			}

		} else if (props.modulo == 'collaborator-coord-classroom') { // <-- Obsoleto
			if (!form.id_classroom) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.post(route(ruta, {
					'id': props.src_id,
					//'id_classroom' : form.id_classroom,
					'data_aulas': checkedFilters.value
				}
				))
				console.log(checkedFilters.value)
				cleanVal()
				//if (!props.debugInertia) Inertia.reload({ only: ['object']})// <-- Actualiza una propiedad en este caso el with(classrooms) que está en object
			}

		} else if (props.modulo == 'collaborator-course') {
			if (checkedFilters.value.length < 1) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.post(route(ruta, {
					'id': props.src_id,
					//'id_course' : form.id_course,
					'data_courses': checkedFilters.value
				}
				))
				cleanVal()
				//if (!props.debugInertia) Inertia.reload({ only: ['object', 'collaborator_courses', 'classrooms_courses']})// <-- Actualiza una propiedad en este caso el with(courses) que está en object
				//Inertia.reload({ only: ['object', 'collaborator_courses'], preserveState: true})
				//listar(selectCriterio.value, buscarCriterio.value)
			}

		} else if (props.isRef) {
			if (!form.label || !form.ref) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.post(route(ruta, {
					'label': form.label,
					'ref': form.ref
				}
				))
				cleanVal()
			}

		} else {
			if (!form.label) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.post(route(ruta, {
					'label': form.label
				}
				))
				cleanVal()
			}

		}

	} else if (rowAction.value == 'actualizar') {

		if (props.modulo == 'Nivel') {
			if (!form.label || !form.ref) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.put(route(ruta, {
					'id': rowID.value,
					'label': form.label,
					'label_short': form.label_short ?? null,
					'ref': form.ref,
					'id_parent': form.parent ? form.parent : null,
					'position': form.position,
					'ciclo_curricular': form.ciclo_curricular,
					'entity': form.entity !== null ? form.entity : null
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'Curso') {
			if (!form.label || !form.id_course_area || !form.id_level || !form.anio) {// || !form.ref
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.put(route(ruta, {
					'id': rowID.value,
					'label': form.label,
					'label_short': form.label_short ?? null,
					'ref': form.ref,
					'id_level': form.id_level,
					'id_course_area': form.id_course_area,
					'anio': form.anio,
					'anio_fin': form.anio_fin,
					'description': form.description,
					'search_criterio': selectCriterio.value,
					'search_buscar': buscarCriterio.value
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'Área curricular') {
			if (!form.position || !form.label || !form.ref) {// || !form.ref
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.put(route(ruta, {
					'id': rowID.value,
					'ref': form.ref,
					'label': form.label,
					'position': form.position,
					'search_criterio': selectCriterio.value,
					'search_buscar': buscarCriterio.value
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'competencia') {
			if (!form.label || !form.id_course_area) {// || !form.ref
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.put(route(ruta, {
					'id': rowID.value,
					'label': form.label,
					'id_course_area': form.id_course_area,
					'ciclos': form.ciclos,
					'description': form.description,
					'search_criterio': selectCriterio.value,
					'search_buscar': buscarCriterio.value
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'ayuda') {
			if (!form.label || !form.description || !form.type) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.put(route(ruta, {
					'id': rowID.value,
					'label': form.label,
					'type': form.type,
					'description': form.description,
					'search_criterio': selectCriterio.value,
					'search_buscar': buscarCriterio.value
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'Aula') {
			if (!form.label || !form.ref || !form.id_level) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.put(route(ruta, {
					'id': rowID.value,
					'label': form.label,
					'secondary_label': form.secondary_label ?? null,
					'label_short': form.label_short ?? null,
					'id_level': form.id_level ?? null,
					'ref': form.ref,
					'note': form.note ?? null,
					'resolution': form.resolution ?? null,
					'type': form.type,
					'id_modular_code': form.id_modular_code ?? null,
					'search_type': props.param.paramstatic1 ?? null,
					'search_criterio': selectCriterio.value,
					'search_buscar': buscarCriterio.value
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'modularcode') {
			if (!form.ref || !form.id_level || !form.id_institution) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.put(route(ruta, {
					'id': rowID.value,
					'id_institution': form.id_institution,
					'label': form.label,
					'id_level': form.id_level,
					'ref': form.ref
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'institution') {
			if (!form.label || !form.ref || !form.short_label || !form.resolution || !form.address) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.put(route(ruta, {
					'id': rowID.value,
					'resolution': form.resolution,
					'label': form.label,
					'short_label': form.short_label,
					'ref': form.ref,
					'address': form.address,
					'note': form.note
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'constante') {
			if (!form.name || !form.type || !form.note) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.put(route(ruta, {
					'id': rowID.value,
					'name': form.name,
					'type': form.type,
					'note': form.note,
					'value': form.value,
					'visible': form.visible,
					'position': form.position,
					'origin_coord': props.nostatus,
					'search_criterio': selectCriterio.value,
					'search_buscar': buscarCriterio.value
				}
				))
				cleanVal()
			}
		} else if (props.modulo == 'traductor') {
			if (!form.transkey || !form.transvalue) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.put(route(ruta, {
					'id': rowID.value,
					'id_level': form.id_level,
					'transkey': form.transkey,
					'transvalue': form.transvalue,
				}
				))
				cleanVal()
			}
		} else if (props.modulo == 'holiday') {
			if (!form.day || !form.month || !form.ref) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.put(route(ruta, {
					'id': rowID.value,
					'ref': form.ref,
					'label': form.label,
					'day': form.day,
					'month': form.month,
					'year': form.year
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'collaboratorhour') {
			if (!form.hora_entrada || !form.hora_salida || !form.ref) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.put(route(ruta, {
					'id': rowID.value,
					'ref': form.ref,
					'label': form.label,
					'hora_entrada': form.hora_entrada,
					'hora_salida': form.hora_salida,
					'tolerancia_tarde': form.tolerancia_tarde,
					'hour_rest': form.hour_rest
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'collaboratorturn') {
			if (!form.ref) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.put(route(ruta, {
					'id': rowID.value,
					'ref': form.ref,
					'label': form.label,
					'id_hour_monday': form.id_hour_monday,
					'id_hour_tuesday': form.id_hour_tuesday,
					'id_hour_wednesday': form.id_hour_wednesday,
					'id_hour_thursday': form.id_hour_thursday,
					'id_hour_friday': form.id_hour_friday,
					'id_hour_saturday': form.id_hour_saturday,
					'id_hour_sunday': form.id_hour_sunday
				}
				))
				cleanVal()
			}

		} else if (props.modulo == 'mark') { // Tabla simple
			if (!form.label || !form.url) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.put(route(ruta, {
					'id': rowID.value,
					'label': form.label,
					'description': form.description,
					'url': form.url,
					//'target' : form.target,
					'color': form.color,
					'position': form.position
				}
				))
				cleanVal()
			}

		} else if (props.isRef) {// <-- Como penultima opción si tiene ref
			if (!form.label || !form.ref) {
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.put(route(ruta, {
					'id': rowID.value,
					'label': form.label,
					'ref': form.ref
				}
				))
				cleanVal()
			}

		} else {
			if (!form.label) {// <-- Y como última opción si sólo es label
				isModalActive.value = true
				isErrorForm.value = true
			} else {
				Inertia.put(route(ruta, {
					'id': rowID.value,
					'label': form.label
				}
				))
				cleanVal()
			}

		}

	} else {
		// Activar, desactivar o eliminar
		if (props.modulo == 'collaborator-course') {
			Inertia.put(route(ruta, {
				//'id' : rowID.value,
				'id': rowPivot1.value,
				'id_course': rowPivot2.value
			}
			))
			cleanVal()
			//if (!props.debugInertia) Inertia.reload({ only: ['object'], preserveState: true})// <-- Actualiza una propiedad en este caso el with(classrooms) que está en object
		} else if (props.modulo == 'collaboratorturn-user') {
			//alert('Hola: '+rowPivot1.value+' - '+rowPivot2.value)
			Inertia.put(route(ruta, {
				//'id' : rowID.value,
				'id': rowPivot1.value,
				'id_collaboratorturn': rowPivot2.value
			}
			))
			cleanVal()
			//if (!props.debugInertia) Inertia.reload({ only: ['object'], preserveState: true})// <-- Actualiza una propiedad en este caso el with(classrooms) que está en object
		} else if (props.modulo == 'collaborator-classroom') {
			Inertia.put(route(ruta, {
				'id': rowID.value,
				'id_collaborator': rowPivot1.value,
				'id_classroom': rowPivot2.value,
				'deleteAllSameAula': deleteAllSameAula.value
			}
			))
			cleanVal()
			//if (!props.debugInertia) Inertia.reload({ only: ['object'], preserveState: true})// <-- Actualiza una propiedad en este caso el with(classrooms) que está en object
		} else if (props.modulo == 'Aula') {
			Inertia.put(route(ruta, {
				'id': rowID.value,
				'search_type': props.param.paramstatic1 ?? null,
				'search_criterio': selectCriterio.value,
				'search_buscar': buscarCriterio.value
			}
			))
			cleanVal()
		} else {
			Inertia.put(route(ruta, {
				'id': rowID.value,
				'search_criterio': selectCriterio.value,
				'search_buscar': buscarCriterio.value
			}
			))
			cleanVal()
		}


	}

}

const isCancel = () => {
	cleanVal()
}

const deleteAllSameAula = ref(false)// <-- Para eliminar varias aulas
//const ayudaEditor = ref(null)// <-- Para limpiar contenido de editor
const editorQuill = ref(null)// <-- Para limpiar contenido de editor
const cleanEditor = ref(true)

const cleanVal = () => {

	if (cleanEditor.value && (props.modulo == 'ayuda' || props.modulo == 'competencia')) {// <-- No borrar si cierro el editor en nueva edición
		form.type = ''
		form.label = ''
		form.description = ''
		//this.$refs.ayudaEditor.setHtml('')// <-- Or setContents('')
		//ayudaEditor.value.setContents('')// <-- 
		editorQuill.value.setContents('')// <-- Limpiar editor Quill
	}
	if (props.modulo == 'classroom') {
		if (props.param && props.param.hasOwnProperty("paramstatic1") && props.param.paramstatic1) {
			form.type = props.param.paramstatic1
		} else {
			form.type = 0
		}

	} else {
		form.type = ''
	}
	//form.type = props.modulo == 'classroom' ? 0 : ''
	//form.label = ''
	//form.description = ''


	//form.type = ''
	rowID.value = 0;
	rowAction.value = ''
	isErrorForm.value = false
	form.label = ''
	form.secondary_label = ''
	form.label_short = ''
	form.short_label = ''
	form.ref = ''
	form.parent = null
	form.id_level = null
	form.id_institution = 0
	form.id_modular_code = 0
	form.id_course_area = null
	form.anio = ''

	form.address = ''
	form.description = ''
	form.note = ''
	form.position = 0
	form.resolution = ''
	rowTextArea.value = 15
	form.id_course = null
	form.id_classroom = null
	rowPivot1.value = 0
	rowPivot2.value = 0
	form.tutor = (props.isCoord ? 1 : 0)

	form.name = ''
	form.visible = 0
	form.admin = 0
	form.value = ''
	form.ciclo_curricular = ''
	form.ciclos = ''

	deleteAllSameAula.value = false

	// Cursos de colaborador
	checkedFilters.value = []
	//filters.value = []
	filtered.value = []
	search.value = ''
	allSelected.value = false
	selectAllText.value = 'Seleccionar todo'
	activeTrigger.value = false
	dropdown.value = false
	showLoader.value = false

	// Level entity
	form.entity = 1

	form.day = '01'
	form.month = '01'
	form.year = 0;
	form.hora_entrada = ''
	form.hora_salida = ''
	form.tolerancia_tarde = ''
	form.hour_rest = ''
	form.id_hour_monday = 0
	form.id_hour_tuesday = 0
	form.id_hour_wednesday = 0
	form.id_hour_thursday = 0
	form.id_hour_friday = 0
	form.id_hour_saturday = 0
	form.id_hour_sunday = 0
	form.id_collaboratorturn = 0

	form.url = ''
	//form.target = 1
	form.color = 'red'

}
//console.log(rowTextArea.value)

const refreshList = (refresh = []) => {

	if (!props.debugInertia) Inertia.reload({ only: refresh })// <-- Se envía un array pues antes era: ['object']

}

const showOtherOption = ref((props.isCoord ? true : false)) //<-- Si es coord mostrar todas las aulas

// Pruewba multiselect
//if (props.modulo == 'collaborator-course') {
/* const filters = ref([
	"Bungalow",
	"Chalet",
	"Guesthouse",
	"Hotel",
	"Townhouse",
	"Apartment",
	"Boutique hotel",
	"Cabin",
	"Guest suite",
	"Hostel",
	"Loft",
	"Villa"
  ]) */
//console.log(props.select1)
const filters = ref([])
if (props.modulo == 'collaborator-classroom') {
	filters.value = props.select2
} else {
	filters.value = props.select1
}
const filtered = ref([])
const courseLevelRef = ref("")
const levelRef = ref("")
const search = ref("")
const checkedFilters = ref([])
const allSelected = ref(false)
const selectAllText = ref('Seleccionar todo')
const activeTrigger = ref(false)
const dropdown = ref(false)
const showLoader = ref(false)

/* const filteredList = computed(() => {
  console.log(checkedFilters.value)
  return filters.value.filter(item => {
	  return item.toLowerCase().includes(search.value.toLowerCase());
	});
    
}) */

const filteredList = computed(() => {
	//console.log(checkedFilters.value)
	return filtered.value = filters.value.filter(item => {
		return item.label.toLowerCase().includes(search.value.toLowerCase());
	});

})

const selectAll = () => {
	checkedFilters.value = [];
	selectAllText.value = selectAllText.value == "Seleccionar todo" ? 'Limpiar todo' : 'Seleccionar todo';
	if (allSelected.value) {
		for (const filter in filtered.value) {
			checkedFilters.value.push(filtered.value[filter].id.toString());
		}
	}
}

const showDropdown = () => {
	if (dropdown.value == false) {
		dropdown.value = true;
		activeTrigger.value = true;
		TweenMax.fromTo(
			"#dropdown",
			0.55,
			{
				autoAlpha: 0,
				y: -10
			},
			{
				autoAlpha: 1,
				y: 0,
				ease: Power2.easeOut
			}
		);
	} else {
		dropdown.value = false;
		activeTrigger.value = false;
		TweenMax.to(
			"#dropdown",
			0.2,
			{
				autoAlpha: 0,
				y: -10,
				ease: Power2.easeOut
			});
	}

}

//const customScroll = new SimpleBar(document.getElementById('customScroll'))
//}

const formatDate = (date) => {
	//var now = new Date().toLocaleDateString()
	var date = new Date(date)// <-- Con let no funcionaba
	//let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
	let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
	return result
}

const formatDateTime = (datetime) => {
	var date = new Date(datetime)// <-- Con let no funcionaba
	//let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
	let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear() + '-' + (date.getHours() > 9 ? '' : '0') + date.getHours() + ':' + (date.getMinutes() > 9 ? '' : '0') + date.getMinutes()
	return result
}


</script>
    
<template>
	<!-- Modal -->
	<CardBoxModal v-model="isModalActive" hasCancel :title="(titleModal + ' ' + title)" @confirm="isConfirm" @cancel="isCancel" :sizeModal="(modulo == 'ayuda' ? 'ajuste' : '')">
		<!--<p>Actualizar <b>{{ titleModal }}</b></p>-->{{ rowID }}
		<div v-if="isErrorForm" class="mb-4">
			<div class="font-medium text-red-600">Ups! Debe registrar los campos requeridos *</div>
			<!--<ul class="mt-3 list-disc list-inside text-sm text-red-600">
            <li>The label field is required.</li>
          </ul>-->
		</div>

		<!-- Formulario @submit.prevent="submit" -->
		<form>
			<template v-if="(isRef || modulo == 'Nivel' || modulo == 'Curso')"><!--|| modulo=='Curso'-->
				<div>
					<BreezeLabel for="ref" :value="'Código' + (modulo == 'Curso' ? ' (ejem. Geometría : GEOM_SEC2)' : '')" :required="true" />
					<BreezeInput id="ref" type="text" class="mt-1 block w-full" v-model="form.ref" required autocomplete="ref" />
				</div>
				<!-- <div>
              <BreezeLabel for="nombre" value="Nombre" :required="true"/>
              <BreezeInput id="label" type="text" class="mt-1 block w-full" v-model="form.label" required autocomplete="label" />
            </div> -->
			</template>
			<!-- Nivel -->
			<template v-if="modulo == 'Nivel'">
				<div>
					<BreezeLabel for="nombre" value="Nombre" :required="true" />
					<BreezeInput id="label" type="text" class="mt-1 block w-full" v-model="form.label" required autocomplete="label" />
				</div>
				<div>
					<BreezeLabel for="label_short" value="Nombre corto (ejemplo: 2do)" />
					<BreezeInput id="label_short" type="text" class="mt-1 block w-full" v-model="form.label_short" required autocomplete="label_short" />
				</div>
				<div>
					<BreezeLabel for="parent" value="Añadir en" />
					<!--<BreezeInput id="parent" type="text" class="mt-1 block w-full" v-model="form.parent" required autofocus autocomplete="parent" />-->
					<select v-model="form.parent" class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option v-for="option in select1" :value="option.id">{{ option.label }}</option>
					</select>
				</div>
				<div>
					<BreezeLabel for="position" value="Posición" />
					<BreezeInput id="position" type="number" class="mt-1 block w-full" v-model="form.position" required autocomplete="position" />
				</div>
				<div>
					<BreezeLabel for="ciclo" value="Ciclo curricular al que pertenece este nivel ejem: 2" />
					<BreezeInput id="ciclo" type="text" class="mt-1 block w-full" v-model="form.ciclo_curricular" required autocomplete="ciclo" />
				</div>
				<div v-if="select2.length">
					<BreezeLabel for="entity" :value="'Entidad' + ' (empresa)'" />
					<select v-model="form.entity" class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<!-- <option value="0" selected></option> -->
						<option v-for="(option, key) in select2" :value="key">{{ option }}</option>
					</select>
				</div>
			</template>
			<!-- Área Curricular -->
			<template v-else-if="modulo == 'Área curricular'">
				<div>
					<BreezeLabel for="nombre" value="Nombre" :required="true" />
					<BreezeInput id="label" type="text" class="mt-1 block w-full" v-model="form.label" required autocomplete="label" />
				</div>
				<div>
					<BreezeLabel for="position" value="Posición" />
					<BreezeInput id="position" type="number" class="mt-1 block w-full" v-model="form.position" required autocomplete="position" />
				</div>
			</template>
			<!-- Competnecias -->
			<template v-else-if="modulo == 'competencia'">
				<div>
					<BreezeLabel for="nombre" value="Nombre" :required="true" />
					<BreezeInput id="label" type="text" class="mt-1 block w-full" v-model="form.label" required autocomplete="label" />
				</div>
				<div>
					<BreezeLabel for="area" value="Área curricular" :required="true" />
					<!--<BreezeInput id="parent" type="text" class="mt-1 block w-full" v-model="form.parent" required autofocus autocomplete="parent" />-->
					<select v-model="form.id_course_area" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option v-for="option in select1" :value="option.id">{{ option.label }}</option>
					</select>
				</div>
				<div>
					<BreezeLabel for="ciclos" value="Ciclos (números separados por coma ejem: 1,2,3)" />
					<BreezeInput id="ciclos" type="text" class="mt-1 block w-full" v-model="form.ciclos" required autocomplete="ciclos" />
				</div>
				<div>
					<BreezeLabel for="descripcion" value="Descripción (opcional)" />
					<QuillEditor ref="editorQuill" style="min-height:100px;" v-model:content="form.description" contentType="html" toolbar="essential" theme="snow" /><!-- toolbar essential no requiere de esto :modules="modulesEditor" -->
				</div>

			</template>
			<!-- Cursos -->
			<template v-else-if="modulo == 'Curso'">
				<div>
					<BreezeLabel for="nombre" value="Nombre" :required="true" />
					<BreezeInput id="label" type="text" class="mt-1 block w-full" v-model="form.label" required autocomplete="label" />
				</div>
				<div>
					<BreezeLabel for="nombrecorto" value="Nombre corto" />
					<BreezeInput id="label_short" type="text" class="mt-1 block w-full" v-model="form.label_short" />
				</div>
				<div>
					<BreezeLabel for="area" value="Nivel/Grado" :required="true" />
					<!--<BreezeInput id="parent" type="text" class="mt-1 block w-full" v-model="form.parent" required autofocus autocomplete="parent" />-->
					<select v-model="form.id_level" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option v-for="option in select2" :value="option.id">{{ option.label }}</option>
					</select>
				</div>
				<div>
					<BreezeLabel for="area" value="Área curricular" :required="true" />
					<!--<BreezeInput id="parent" type="text" class="mt-1 block w-full" v-model="form.parent" required autofocus autocomplete="parent" />-->
					<select v-model="form.id_course_area" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option v-for="option in select1" :value="option.id">{{ option.label }}</option>
					</select>
				</div>
				<div>
					<BreezeLabel for="anio" value="Año de incio de uso del curso" :required="true" />
					<BreezeInput id="anio" type="text" class="mt-1 block w-full" v-model="form.anio" required autocomplete="Año" />
					<BreezeLabel for="anio_fin" value="Año de fin que se usó el curso"/>
					<BreezeInput id="anio_fin" type="text" class="mt-1 block w-full" v-model="form.anio_fin" required autocomplete="Año" />
				</div>
				<div>
					<BreezeLabel for="note" value="Descripción" />
					<textarea id="note" class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full" v-model="form.description" autocomplete="description" />
				</div>
			</template>
			<!-- Aula -->
			<template v-else-if="modulo == 'Aula'">
				<div>
					<BreezeLabel for="type" value="Tipo" :required="true" />
					<select v-model="form.type" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option value="0">Estándar</option>
						<option value="1">Teórica</option>
					</select>
				</div>
				<div v-if="form.type == 1">
					<BreezeLabel for="modular_code" value="Código modular" :required="true" />
					<!--<BreezeInput id="parent" type="text" class="mt-1 block w-full" v-model="form.parent" required autofocus autocomplete="parent" />-->
					<select v-model="form.id_modular_code" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option v-for="option in select2" :value="option.id">{{ option.label + '_' + option.label_2 + '_' + option.label_3 }}</option>
					</select>
				</div>
				<div>
					<BreezeLabel for="level" value="Nivel/Grado Turno mañana" :required="true" />
					<!--<BreezeInput id="parent" type="text" class="mt-1 block w-full" v-model="form.parent" required autofocus autocomplete="parent" />-->
					<select v-model="form.id_level" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option v-for="option in select1" :value="option.id">{{ option.label }}</option>
					</select>
				</div>
				<div>
					<BreezeLabel for="ref" :value="(form.type == 1 ? 'Código (agregar en el sufijo el código modular ejemplo: PRIM3A123456)' : 'Código (ejemplo: PRIM3A para el caso de Primaria tercero A')" :required="true" />
					<BreezeInput id="ref" type="text" class="mt-1 block w-full" v-model="form.ref" required autocomplete="ref" title="Si el aula está relacionada a un código modular, debe poner el código como sufijo" />
				</div>
				<div>
					<BreezeLabel for="nombre" value="Nombre (ejemplo: Primaria segundo B)" :required="true" />
					<BreezeInput id="label" type="text" class="mt-1 block w-full" v-model="form.label" required autocomplete="label" />
				</div>

				<div>
					<BreezeLabel for="label_short" value="Nombre corto (ejemplo: 2do A o solo A)" />
					<BreezeInput id="label_short" type="text" class="mt-1 block w-full" v-model="form.label_short" required autocomplete="label_short" />
				</div>
				<div>
					<BreezeLabel for="secondary_label" value="Nombre secundario (ejemplo: patitos, pollitos)" />
					<BreezeInput id="secondary_label" type="text" class="mt-1 block w-full" v-model="form.secondary_label" required autocomplete="secondary_label" />
				</div>
				<!-- <div>
              <BreezeLabel for="resolution" value="Resolución" />
              <BreezeInput id="resolution" type="text" class="mt-1 block w-full" v-model="form.resolution" required autocomplete="resolution" />
            </div> -->
				<div>
					<BreezeLabel for="description" value="Descripción (opcional)" />
					<textarea id="description" class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full" v-model="form.description" autocomplete="description" />
				</div>
			</template>
			<template v-else-if="modulo == 'ayuda'">
				<div>
					<BreezeLabel for="Pregunta" value="Pregunta" :required="true" />
					<BreezeInput id="label" type="text" class="mt-1 block w-full" v-model="form.label" required autocomplete="label" />
				</div>
				<div>
					<BreezeLabel for="type" value="Tipo" :required="true" />
					<select v-model="form.type" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option value="estudiante" selected>Estudiante/todos</option>
						<option value="maestro" selected>Maestro o tutor</option>
						<option value="colaborador" selected>Colaborador/Configuración</option>
					</select>
				</div>
				<div>
					<!-- <span>Descripción (Html) <span class="text-red-600" > * </span></span><span @click="showHtmlText=!showHtmlText">Vista previa<BaseIcon :path="mdiEye" :size="18" class="mr-3 " /></span>
              <
              <div v-else class="p-2" v-html="form.description"></div> -->
					<BreezeLabel for="description" value="Descripción" :required="true" /><span @click="showHtmlText = !showHtmlText">
						<BaseIcon :path="mdiEye" :size="18" class="mr-3 " />HTML (Por ahora ingresar las imágenes src y url)
					</span>
					<!-- Ref: https://vueup.github.io/vue-quill/guide/toolbar.html -->
					<!-- PRopiedades: readOnly, toolbar="" -> Sin toolbar, :toolbar="['']" -> Agregar toolbarr personalizado sólo resaltado y sub indice -->
					<!-- https://github.com/surmon-china/vue-quill-editor/issues/228 -> Aumentar área de trabajo -->
					<QuillEditor ref="editorQuill" class="max-h-[450px] overflow-y-auto min-h-[300px]" v-if="showHtmlText == false" v-model:content="form.description" contentType="html" toolbar="full" theme="snow" :modules="modulesEditor" rows="10" />
					<textarea v-else :rows="rowTextArea" id="description" class="max-h-[550px] min-h-[450px] overflow-y-auto border-gray-300 fmaxocus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full" v-model="form.description" required autocomplete="description" />

					<!-- <Editor/> -->
					<!-- <div id="editor">
              <mavonEditor v-model="form.description" style="height: 100%"></mavonEditor>
            </div> -->

				</div>
			</template>
			<template v-else-if="modulo == 'collaborator-classroom'">
				<div v-if="!isCoord">
					<BreezeLabel for="istutor" value="Profesor/Tutor" />
					<select v-model="form.tutor" class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="0" selected>Profesor/a</option>
						<option value="1" selected>Tutor/a</option>
					</select>
				</div>

				<div>
					<label class="block font-medium text-sm text-gray-700" for="classroom"><span>Aula/Sección <span class="text-red-600"> * </span></span>
						<span class="text-blue-600" v-if="!showOtherOption" @click="showOtherOption = !showOtherOption"> [Mostrar todas las aulas]</span>
						<span class="text-blue-600" v-if="showOtherOption" @click="showOtherOption = !showOtherOption"> [Limitar aulas]</span>
					</label>
					<!--<BreezeInput id="parent" type="text" class="mt-1 block w-full" v-model="form.parent" required autofocus autocomplete="parent" />-->
					<select v-model="form.id_classroom" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full" @change="(form.id_classroom ? courseLevelRef = select1.find(item => item.id === form.id_classroom).ref : ''), search = courseLevelRef.slice(0, -1)">
						<option value="" selected></option>
						<option v-if="!showOtherOption" v-for="option in select3" :value="option.id">{{ option.label + ' - ' + option.ref }}</option><!-- Mostrar aulas sólo relacionados al nivel del curso que enseña -->
						<option v-else v-for="option in select1" :value="option.id">{{ option.label + ' - ' + option.ref }}</option><!-- Mostrar todas las aulas -->
					</select>

				</div>

				<div v-if="form.tutor == 0">
					<BreezeLabel for="course" value="Curso/s" />
					<!--<BreezeInput id="parent" type="text" class="mt-1 block w-full" v-model="form.parent" required autofocus autocomplete="parent" />-->
					<!--  <select v-model="form.id_course" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
                <option value="" selected></option>
                <option v-for="option in select2" :value="option.id">{{ option.label }}</option>
              </select> -->

					<!-- Multiselect -->
					<div class="checkbox-select">
						<!-- <div class="checkbox-select__trigger" :class="{ isActive: activeTrigger }" @click="showDropdown">
                  <span class="checkbox-select__title">Selecciona los cursos</span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"><path d="M121.3 34.6c-1.6-1.6-4.2-1.6-5.8 0l-51 51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8 0-1.6 1.6-1.6 4.2 0 5.8l53.9 53.9c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2.1-5.8z"/></svg>
                </div> -->
						<div id="dropdown" class="overflow-auto" :class="{ activeSearch: showLoader }">

							<div class="lg:flex  grid grid-cols-1 gap-4">
								<div class="inline">
									<input type="text" @focus="showLoader = true" @blur="showLoader = false" placeholder="Filtrar curso o grado" v-model="search">
								</div>
								<div class="">
									<div class="checkbox-select__select-all"><label for="selectAll" class="mr-3">{{ selectAllText }}</label>
										<input type="checkbox" id="selectAll" @click="selectAll" v-model="allSelected">
									</div>
									<div class="checkbox-select__info">{{ checkedFilters.length }} SELECCIONADO</div>
								</div>
							</div>
							<div class="overflow-y-auto h-64 ...">
								<ul id="customScroll" class="checkbox-select__filters-wrapp" data-simplebar-auto-hide="false">
									<li v-for="(filter, index) in filteredList">
										<div class="checkbox-select__check-wrapp">
											<input :id="index" class="conditions-check" v-model="checkedFilters" :value="filter.id" type="checkbox">
											<label :for="index" class="ml-2">{{ filter.label }}</label>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<!-- Fin de multiselect -->
				</div>
			</template>
			<template v-else-if="modulo == 'collaborator-coord-classroom'">

				<div>
					<BreezeLabel for="Nivel" value="Nivel" />
					<select v-model="form.nivel" class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full" @change="(form.nivel ? levelRef = select1.find(item => item.id === form.nivel).ref : ''), search = levelRef.slice(0, -1)">
						<option value="" selected></option>
						<option value="INI" selected>Inicial</option>
						<option value="PRIM" selected>Primaria</option>
						<option value="SEC" selected>Secundaria</option>
					</select>
				</div>
				<div v-if="form.tutor == 0">
					<BreezeLabel for="course" value="Curso/s" />
					<!--<BreezeInput id="parent" type="text" class="mt-1 block w-full" v-model="form.parent" required autofocus autocomplete="parent" />-->
					<!--  <select v-model="form.id_course" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
                <option value="" selected></option>
                <option v-for="option in select2" :value="option.id">{{ option.label }}</option>
              </select> -->

					<!-- Multiselect -->
					<div class="checkbox-select">
						<!-- <div class="checkbox-select__trigger" :class="{ isActive: activeTrigger }" @click="showDropdown">
                  <span class="checkbox-select__title">Selecciona los cursos</span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"><path d="M121.3 34.6c-1.6-1.6-4.2-1.6-5.8 0l-51 51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8 0-1.6 1.6-1.6 4.2 0 5.8l53.9 53.9c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2.1-5.8z"/></svg>
                </div> -->
						<div id="dropdown" class="overflow-auto" :class="{ activeSearch: showLoader }">

							<div class="lg:flex  grid grid-cols-1 gap-4">
								<div class="inline">
									<input type="text" @focus="showLoader = true" @blur="showLoader = false" placeholder="Filtrar" v-model="search">
								</div>
								<div class="">
									<div class="checkbox-select__select-all"><label for="selectAll" class="mr-3">{{ selectAllText }}</label>
										<input type="checkbox" id="selectAll" @click="selectAll" v-model="allSelected">
									</div>
									<div class="checkbox-select__info">{{ checkedFilters.length }} SELECCIONADO</div>
								</div>
							</div>
							<div class="overflow-y-auto h-64 ...">
								<ul id="customScroll" class="checkbox-select__filters-wrapp" data-simplebar-auto-hide="false">
									<li v-for="(filter, index) in filteredList">
										<div class="checkbox-select__check-wrapp">
											<input :id="index" class="conditions-check" v-model="checkedFilters" :value="filter.id" type="checkbox">
											<label :for="index" class="ml-2">{{ filter.label }}</label>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<!-- Fin de multiselect -->
				</div>
			</template>
			<template v-else-if="modulo == 'collaborator-course'">
				<div>
					<BreezeLabel for="course" value="Cursos a asignar" :required="true" />
					<!--<BreezeInput id="parent" type="text" class="mt-1 block w-full" v-model="form.parent" required autofocus autocomplete="parent" />-->
					<!-- <select v-model="form.id_course" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
                <option value="" selected></option>
                <option v-for="option in select1" :value="option.id">{{ option.label }}</option>
              </select> -->
					<!-- Multiselect -->
					<div class="checkbox-select">
						<!-- <div class="checkbox-select__trigger" :class="{ isActive: activeTrigger }" @click="showDropdown">
                  <span class="checkbox-select__title">Selecciona los cursos</span>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 129"><path d="M121.3 34.6c-1.6-1.6-4.2-1.6-5.8 0l-51 51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8 0-1.6 1.6-1.6 4.2 0 5.8l53.9 53.9c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2.1-5.8z"/></svg>
                </div> -->
						<div id="dropdown" class="overflow-auto" :class="{ activeSearch: showLoader }">

							<div class="lg:flex  grid grid-cols-1 gap-4">
								<div class="inline">
									<input type="text" @focus="showLoader = true" @blur="showLoader = false" placeholder="Filtrar curso o grado" v-model="search">
								</div>
								<div class="">
									<div class="checkbox-select__select-all"><label for="selectAll" class="mr-3">{{ selectAllText }}</label>
										<input type="checkbox" id="selectAll" @click="selectAll" v-model="allSelected">
									</div>
									<div class="checkbox-select__info">{{ checkedFilters.length }} SELECCIONADO</div>
								</div>
							</div>
							<div class="overflow-y-auto h-64 ...">
								<ul id="customScroll" class="checkbox-select__filters-wrapp" data-simplebar-auto-hide="false">
									<li v-for="(filter, index) in filteredList">
										<div class="checkbox-select__check-wrapp">
											<input :id="index" class="conditions-check" v-model="checkedFilters" :value="filter.id" type="checkbox">
											<label :for="index" class="ml-2">{{ filter.label }}</label>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<!-- Fin de multiselect -->
				</div>
			</template>
			<template v-else-if="modulo == 'constante'">
				<div>
					<BreezeLabel for="name" value="Codigo" :required="true" />
					<BreezeInput id="name" type="text" class="mt-1 block w-full" v-model="form.name" required autocomplete="name" :readOnly="(nostatus ? true : false)" />
				</div>
				<div>
					<BreezeLabel for="description" value="Descripción" :required="true" />
					<BreezeInput id="note" type="text" class="mt-1 block w-full" v-model="form.note" required autocomplete="note" :readOnly="(nostatus ? true : false)" />
				</div>
				<div v-if="!nostatus">
					<BreezeLabel for="type" value="Tipo" :required="true" />
					<select v-model="form.type" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option value="string" selected>Texto</option>
						<option value="number" selected>Número</option>
						<option value="sino" selected>SiNo</option>
						<option value="date" selected>Fecha</option>
						<option value="html" selected>Html</option>
					</select>
				</div>
				<div v-if="!nostatus && rowAction != 'actualizar'">
					<BreezeLabel for="visible" value="Visible" :required="true" />
					<select v-model="form.visible" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="0" selected>No</option>
						<option value="1" selected>Si</option>
					</select>
				</div>
				<div v-if="!nostatus">
					<BreezeLabel for="position" value="Posición" />
					<BreezeInput id="position" type="number" class="mt-1 block w-full" v-model="form.position" required autocomplete="position" />
				</div>
				<div>
					<span v-if="form.type == 'html'">Ver texto Html<span class="text-red-600" ></span><span @click="showHtmlText=!showHtmlText">Vista previa<BaseIcon :path="mdiEye" :size="18" class="mr-3 "/></span></span>
              
					<BreezeLabel for="Valor" value="Valor" :required="true" />
					<select v-if="form.type == 'sino'" v-model="form.value" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="0" selected>No</option>
						<option value="1" selected>Si</option>
					</select>
					<BreezeInput v-else-if="form.type == 'number'" id="label" type="number" class="mt-1 block w-full" v-model="form.value" required autocomplete="value" />
					<BreezeInput v-else-if="form.type == 'date'" id="label" type="date" class="mt-1 block w-full" v-model="form.value" required autocomplete="value" />
					
					<!-- Add texto enriquecido -->
					<QuillEditor v-else-if="form.type == 'html' && showHtmlText == false" ref="editorQuill" class="max-h-[450px] overflow-y-auto min-h-[300px]" v-model:content="form.value" contentType="html" toolbar="full" theme="snow" :modules="modulesEditor" rows="10" />
					<div v-else-if="form.type == 'html' && showHtmlText == true" class="p-2" v-html="form.value"></div>
					
					<textarea v-else rows="4" id="value" class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full" v-model="form.value" required autocomplete="value" />

				</div>

			</template>
			<div v-else-if="modulo == 'modularcode'">
				<div>
					<BreezeLabel for="institution" value="Sede/Institución" :required="true" />
					<!--<BreezeInput id="parent" type="text" class="mt-1 block w-full" v-model="form.parent" required autofocus autocomplete="parent" />-->
					<select v-model="form.id_institution" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option v-for="option in select1" :value="option.id">{{ option.label }}</option>
					</select>
				</div>

				<div>
					<BreezeLabel for="level" value="Nivel" :required="true" />
					<!--<BreezeInput id="parent" type="text" class="mt-1 block w-full" v-model="form.parent" required autofocus autocomplete="parent" />-->
					<select v-model="form.id_level" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option v-for="option in select2" :value="option.id">{{ option.label }}</option>
					</select>
				</div>
				<div>
					<BreezeLabel for="nombre" value="Nombre (Opcional)" />
					<BreezeInput id="label" type="text" class="mt-1 block w-full" v-model="form.label" autocomplete="label" />
				</div>
			</div>
			<div v-else-if="modulo == 'institution'">
				<BreezeLabel for="nombre" value="Nombre" :required="true" />
				<BreezeInput id="label" type="text" class="mt-1 block w-full" v-model="form.label" required autocomplete="label" />

				<div>
					<BreezeLabel for="short_label" value="Nombre corto" :required="true" />
					<BreezeInput id="short_label" type="text" class="mt-1 block w-full" v-model="form.short_label" required autocomplete="short_label" />
				</div>
				<div>
					<BreezeLabel for="resolution" value="Resolución" :required="true" />
					<BreezeInput id="resolution" type="text" class="mt-1 block w-full" v-model="form.resolution" required autocomplete="resolution" />
				</div>
				<div>
					<BreezeLabel for="address" value="Dirección" :required="true" />
					<BreezeInput id="address" type="text" class="mt-1 block w-full" v-model="form.address" required autocomplete="address" />
				</div>
				<div>
					<BreezeLabel for="note" value="Nota (opcional)" />
					<textarea id="note" class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full" v-model="form.note" autocomplete="note" />
				</div>
			</div>
			<div v-else-if="modulo == 'traductor'">
				<div>
					<BreezeLabel for="level" value="Nivel (Opcional)" :required="true" />
					<select v-model="form.id_level" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option v-for="option in select1" :value="option.id">{{ option.label }}</option>
					</select>
				</div>
				<div>
					<BreezeLabel for="transkey" value="Key" />
					<BreezeInput id="transkey" type="text" class="mt-1 block w-full" v-model="form.transkey" autocomplete="off" />
				</div>
				<div>
					<BreezeLabel for="transvalue" value="Valor" />
					<BreezeInput id="transvalue" type="text" class="mt-1 block w-full" v-model="form.transvalue" autocomplete="off" />
				</div>
			</div>
			<div v-else-if="modulo == 'holiday'">
				<div class="mb-3">
					<BreezeLabel for="ref" value="Código" :required="true" />
					<BreezeInput id="ref" type="text" class="mt-1 block w-full" v-model="form.ref" autocomplete="off" />
				</div>
				<div class="mb-3">
					<BreezeLabel for="label" value="Etiqueta" />
					<BreezeInput id="label" type="text" class="mt-1 block w-full" v-model="form.label" autocomplete="off" />
				</div>
				<div class="mb-3">
					<BreezeLabel for="day" value="Día" :required="true" />
					<select id="day" v-model="form.day" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="0" selected></option>
						<option v-for="index in 31" :value="(index < 10 ? '0' + index : index)">{{ (index < 10 ? '0' + index : index) }}</option>
					</select>
				</div>
				<div class="mb-3">
					<BreezeLabel for="month" value="Mes" :required="true" />
					<select id="month" v-model="form.month" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="0" selected></option>
						<option v-for="index in 12" :value="(index < 10 ? '0' + index : index)">{{ (index < 10 ? '0' + index : index) }}</option>
					</select>
				</div>
				<div class="mb-3">
					<BreezeLabel for="year" value="Año (0, si se repite todos los años)" />
					<BreezeInput id="year" type="text" class="mt-1 block w-full" v-model="form.year" autocomplete="off" />
				</div>

			</div>
			<div v-else-if="modulo == 'collaboratorhour'">
				<div class="mb-3">
					<BreezeLabel for="ref" value="Código" :required="true" />
					<BreezeInput id="ref" type="text" class="mt-1 block w-full" v-model="form.ref" autocomplete="off" />
				</div>
				<div class="mb-3">
					<BreezeLabel for="label" value="Etiqueta" />
					<BreezeInput id="label" type="text" class="mt-1 block w-full" v-model="form.label" autocomplete="off" />
				</div>
				<div class="mb-3">
					<BreezeLabel for="hora_entrada" value="Hora Entrada (ej. 07:00)" :required="true" />
					<BreezeInput id="hora_entrada" type="text" class="mt-1 block w-full" v-model="form.hora_entrada" autocomplete="off" />
				</div>
				<div class="mb-3">
					<BreezeLabel for="hora_salida" value="Hora Salida (ej. 15:30)" :required="true" />
					<BreezeInput id="hora_salida" type="text" class="mt-1 block w-full" v-model="form.hora_salida" autocomplete="off" />
				</div>
				<div class="mb-3">
					<BreezeLabel for="tolerancia_tarde" value="Tolerancia tarde, minutos (ej. 10)" />
					<BreezeInput id="tolerancia_tarde" type="number" class="mt-1 block w-full" v-model="form.tolerancia_tarde" autocomplete="off" />
				</div>
			</div>
			<div v-else-if="modulo == 'collaboratorturn'">
				<div class="mb-3">
					<BreezeLabel for="ref" value="Código" :required="true" />
					<BreezeInput id="ref" type="text" class="mt-1 block w-full" v-model="form.ref" autocomplete="off" />
				</div>
				<div class="mb-3">
					<BreezeLabel for="label" value="Etiqueta" />
					<BreezeInput id="label" type="text" class="mt-1 block w-full" v-model="form.label" autocomplete="off" />
				</div>
				<div class="mb-3">
					<BreezeLabel for="id_hour_monday" value="Horario Lunes" />
					<select id="id_hour_monday" v-model="form.id_hour_monday" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option v-for="option in select1" :value="option.id">{{ option.label }}</option>
					</select>
				</div>
				<div class="mb-3">
					<BreezeLabel for="id_hour_tuesday" value="Horario Martes" />
					<select id="id_hour_tuesday" v-model="form.id_hour_tuesday" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option v-for="option in select1" :value="option.id">{{ option.label }}</option>
					</select>
				</div>
				<div class="mb-3">
					<BreezeLabel for="id_hour_wednesday" value="Horario Miércoles" />
					<select id="id_hour_wednesday" v-model="form.id_hour_wednesday" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option v-for="option in select1" :value="option.id">{{ option.label }}</option>
					</select>
				</div>
				<div class="mb-3">
					<BreezeLabel for="id_hour_thursday" value="Horario Jueves" />
					<select id="id_hour_thursday" v-model="form.id_hour_thursday" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option v-for="option in select1" :value="option.id">{{ option.label }}</option>
					</select>
				</div>
				<div class="mb-3">
					<BreezeLabel for="id_hour_friday" value="Horario Viernes" />
					<select id="id_hour_friday" v-model="form.id_hour_friday" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option v-for="option in select1" :value="option.id">{{ option.label }}</option>
					</select>
				</div>
				<div class="mb-3">
					<BreezeLabel for="id_hour_saturday" value="Horario Sábado" />
					<select id="id_hour_saturday" v-model="form.id_hour_saturday" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option v-for="option in select1" :value="option.id">{{ option.label }}</option>
					</select>
				</div>
				<div class="mb-3">
					<BreezeLabel for="id_hour_sunday" value="Horario Domingo" />
					<select id="id_hour_sunday" v-model="form.id_hour_sunday" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option v-for="option in select1" :value="option.id">{{ option.label }}</option>
					</select>
				</div>
			</div>
			<template v-else-if="modulo == 'collaboratorturn-user'">
				<div class="mb-3">
					<BreezeLabel for="id_collaboratorturn" value="Turno de asistencia" />
					<select id="id_collaboratorturn" v-model="form.id_collaboratorturn" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option v-for="option in select1" :value="option.id">{{ option.label }}</option>
					</select>
				</div>
				<div v-if="select2 && select2.length > 1" class="mb-3">
					<BreezeLabel for="entity" value="Entidad" />
					<select id="entity" v-model="form.entity" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="" selected></option>
						<option v-for="option in select2" :value="option.id">{{ option.label }}</option>
					</select>
				</div>
			</template>
			<template v-else-if="modulo == 'mark'">
				<div>
					<BreezeLabel for="label" value="Nombre" :required="true" />
					<BreezeInput id="label" type="text" class="mt-1 block w-full" v-model="form.label" required autocomplete="label" />
				</div>
				<div>
					<BreezeLabel for="description" value="Descripción (opcional)" />
					<textarea id="description" class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full" v-model="form.description" autocomplete="description" />
				</div>
				<div :class="(form.target ? '' : 'invisible')">
					<BreezeLabel for="url" value="URL (ejemplo: https://unens.com)" :required="true" />
					<BreezeInput id="url" type="text" class="mt-1 block w-full" v-model="form.url" required autocomplete="off" :readOnly="(form.target ? false : true)" />
				</div>
				<div>
					<BreezeLabel for="color" value="Color" /> <button :class="'bg-' + form.color + '-500'" type="button"> ___ </button>
					<select v-model="form.color" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
						<option value="red">Rojo</option>
						<option value="blue">Azul</option>
						<option value="sky">Celeste</option>
						<option value="emerald">Esmeralda</option>
						<option value="green">Verde</option>
						<option value="lime">Lima</option>
						<option value="yellow">Amarillo</option>
						<option value="slate">Gris</option>
						<option value="purple">Púrpura</option>
					</select>
				</div>
				<div>
					<BreezeLabel for="position" value="Posición" />
					<BreezeInput id="position" type="number" class="mt-1 block w-full" v-model="form.position" required autocomplete="position" />
				</div>
			</template>
			<!-- Otro casos de formulario -->
			<div v-else>
				<BreezeLabel for="label" value="Nombre" :required="true" />
				<BreezeInput id="label" type="text" class="mt-1 block w-full" v-model="form.label" required autocomplete="label" />
			</div>
		</form>
		<!--<div class="mt-4">
            <BreezeLabel for="email" value="Email" />
            <BreezeInput id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autocomplete="mail" />
        </div>-->
	</CardBoxModal>

	<CardBoxModal v-model="isModalDangerActive" title="Por Confirmar" button="danger" hasCancel @confirm="isConfirm" @cancel="isCancel">
		<p>Está seguro de <b>{{ rowAction }}</b></p>
		<p>este registro?</p>
	</CardBoxModal>
	<!-- Fin modal -->

	<div v-if="checkedRows.length" class="p-3 bg-gray-100/50 dark:bg-slate-800">
		<span v-for="checkedRow in checkedRows" :key="checkedRow.id" class="inline-block px-2 py-1 rounded-sm mr-2 text-sm bg-gray-100 dark:bg-slate-700">
			{{ checkedRow.name }}
		</span>
	</div>

	<div class="mb-6 items-center justify-between grid lg:grid-cols-5 grid-cols-2 gap-4">
		<div v-if="!nosearchable" class="col-span-1">
			<select class="inline-block border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full" v-model="selectCriterio" placeholder="Seleccione" @change="buscarCriterio = ''">
				<option v-if="modulo != 'collaborator-classroom' && modulo != 'collaborator-coord-classroom' && modulo != 'collaborator-course' && modulo != 'constante'" value="label" selected="selected">Nombre</option>
				<option v-if="modulo == 'constante'" value="name" selected="selected">Nombre</option>
				<option v-if="modulo == 'Nivel'" value="id_parent" selected="selected">Nivel padre</option>
				<!-- <option v-if="modulo == 'Curso'" value="ref" selected="selected">Código</option> -->
				<option v-if="modulo == 'Curso' || modulo == 'Aula'" value="id_level" selected="selected">Nivel/Grado</option>
				<option v-if="modulo == 'modularcode'" value="id_institution" selected="selected">Institucion/Sede Ugel</option>
				<option v-if="modulo == 'modularcode'" value="id_level" selected="selected">Nivel</option>
				<option v-if="modulo == 'Curso' || modulo == 'competencia'" value="id_course_area" selected="selected">Área curricular</option>
				<option v-if="modulo == 'ayuda' || modulo == 'Aula'" value="type" selected="selected">Tipo</option>
				<option v-if="modulo == 'ayuda'" value="description" selected="selected">Desripción</option>
				<option v-if="modulo == 'Aula' || modulo == 'modularcode'" value="ref" selected="selected">Código</option>
				<option v-if="modulo == 'Aula'" value="id_modular_code" selected="selected">Código módular</option>
				<option v-if="modulo == 'institution'" value="resolution" selected="selected">Resolución</option>
				<option v-if="modulo == 'constante'" value="note" selected="selected">Descripción</option>
				<!-- <option v-if="modulo == 'collaborator-classroom'" value="id_classroom" selected="selected">Aula/Sección</option>
          <option v-if="modulo == 'collaborator-course'" value="id_course" selected="selected">Curso</option> -->

				<option v-if="modulo == 'traductor'" value="transkey" selected="selected">Key</option>
				<option v-if="modulo == 'traductor'" value="transvalue" selected="selected">Value</option>

			</select>
		</div>
		<div v-if="!nosearchable" class="lg:col-span-2 col-span-1">
			<!-- Mostrar select y oculter text en casos de curos y levels --><!-- - LRR no ejecjutar al cambiar el valor @change="listar(selectCriterio, buscarCriterio)" -->
			<template v-if="selectCriterio == 'id_parent'">
				<select v-model="buscarCriterio" class="inline-block ml-1 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full">
					<option value="" selected></option>
					<option v-for="option in select1" :value="option.id">{{ option.label }}</option>
				</select>
			</template>
			<template v-else-if="selectCriterio == 'id_course_area'">
				<select v-model="buscarCriterio" class="inline-block ml-1 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full">
					<option value="" selected></option>
					<option v-for="option in select1" :value="option.id">{{ option.label }}</option>
				</select>
			</template>
			<template v-else-if="selectCriterio == 'id_institution' && modulo == 'modularcode'">
				<select v-model="buscarCriterio" class="inline-block ml-1 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full">
					<option value="" selected></option>
					<option v-if="modulo == 'Curso'" v-for="option in select1" :value="option.id">{{ option.label }}</option>
					<option v-else v-for="option in select1" :value="option.id">{{ option.label }}</option>
				</select>
			</template>
			<template v-else-if="selectCriterio == 'id_level' && modulo == 'modularcode'">
				<select v-model="buscarCriterio" class="inline-block ml-1 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full">
					<option value="" selected></option>
					<option v-if="modulo == 'Curso'" v-for="option in select1" :value="option.id">{{ option.label }}</option>
					<option v-else v-for="option in select2" :value="option.id">{{ option.label }}</option>
				</select>
			</template>
			<template v-else-if="selectCriterio == 'id_modular_code' && modulo == 'Aula'">
				<select v-model="buscarCriterio" class="inline-block ml-1 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full">
					<option value="" selected></option>
					<option v-for="option in select2" :value="option.id">{{ option.label + '_' + option.label_2 + '_' + option.label_3 }}</option>
				</select>
			</template>
			<template v-else-if="selectCriterio == 'id_level'">
				<select v-model="buscarCriterio" class="inline-block ml-1 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full">
					<option value="" selected></option>
					<option v-if="modulo == 'Curso'" v-for="option in select2" :value="option.id">{{ option.label }}</option>
					<option v-else v-for="option in select1" :value="option.id">{{ option.label }}</option>
				</select>
			</template>
			<template v-else-if="selectCriterio == 'type'"><!-- Ayuda-->
				<select v-if="modulo == 'Ayuda'" v-model="buscarCriterio" class="inline-block ml-1 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full">
					<option value="" selected></option>
					<option value="estudiante" selected>Estudiante/todos</option>
					<option value="colaborador" selected>Colaborador/Configuración</option>
					<!--  <option v-for="option in select2" :value="option.id">{{ option.label }}</option> -->
				</select>
				<select v-if="modulo == 'Aula'" v-model="buscarCriterio" class="inline-block ml-1 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full">
					<option value="" selected></option>
					<option value="0" selected>Estándar</option>
					<option value="1" selected>Teórica</option>
					<!--  <option v-for="option in select2" :value="option.id">{{ option.label }}</option> -->
				</select>
			</template>
			<template v-else-if="selectCriterio == 'id_classroom'">
				<select v-model="buscarCriterio" class="inline-block ml-1 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full">
					<option value="" selected></option>
					<option v-for="option in select1" :value="option.id">{{ option.label }}</option>
				</select>
			</template>
			<template v-else-if="selectCriterio == 'id_course'">
				<select v-model="buscarCriterio" class="inline-block ml-1 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full">
					<option value="" selected></option>
					<option v-for="option in select1" :value="option.id">{{ option.label }}</option>
				</select>
			</template>
			<!-- Otros casos -->
			<template v-else>
				<BreezeInput id="search" type="text" class="inline-block w-full" v-model="buscarCriterio" autofocus autocomplete="label" @keyup.enter="listar(selectCriterio, buscarCriterio)" />
			</template>
		</div>

		<div v-if="!nosearchable" class="col-span-1">
			<BaseButton color="info" :icon="mdiSearchWeb" @click="listar(selectCriterio, buscarCriterio)" class="inline-block cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600" small label="Buscar" />
		</div>
		<div v-if="!nocreate" :class="nosearchable ? '' : 'col-span-1'">
			<BaseButton v-if="showRefresh" :icon="mdiRefresh" color="info" class="inline-block ml-4 float-right mb-2" icon-size="20" small label="Refresh" @click="refreshList(actionRefresh)" />
			<BaseButton color="info" :icon="mdiPlusCircle" small label="Nuevo" @click="initModal('', 'registrar')" class="inline-block cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right" />

		</div>

		<div class="col-span-1">
			Items ({{ items.length }})
		</div>

	</div>

	<!-- Comentarios -->
	<div v-if="modulo == 'holiday'" class="mb-4">
		<li>Por defecto el año es cero, puede asignar un año por si el festivo no se repetirá en los próximos años.</li>
	</div>

	<template v-if="data.length">
		<!-- Opciones -->
		<div v-if="(modulo == 'collaborator-classroom' && !isCoord)" class="p-4">
			<label class="checkbox">
				<input v-model="deleteAllSameAula" type="checkbox" />
				<span class="check mr-2"> Al borrar un aula/curso, borrar todas de la misma aula</span>
			</label>
		</div>
		<div v-if="items.length > 50" class="p-3 lg:px-6 border-t border-gray-100 dark:border-slate-800">
			<BaseLevel>
				<BaseButtons>
					<BaseButton v-for="page in pagesList" :key="page" :active="page === currentPage" :label="page + 1" :color="page === currentPage ? 'lightDark' : 'whiteDark'" small @click="currentPage = page" />
				</BaseButtons>
				<small>Página {{ currentPageHuman }} de {{ numPages }}</small>
			</BaseLevel>
		</div>
		<table :class="tableclass">
			<thead>
				<tr>
					<th v-if="(modulo == 'Nivel')">Nivel padre</th>
					<th v-if="(isRef || modulo == 'Nivel' || modulo == 'Aula')">Código</th>
					<th v-if="(modulo == 'Curso')">Nivel/Grado</th>
					<th v-if="(modulo == 'Curso' || modulo == 'competencia')">Área</th>

					<th v-if="(modulo == 'modularcode')">Inst./Sede</th>
					<th v-if="(modulo == 'modularcode')">Nivel</th>

					<th v-if="(modulo == 'ayuda')">Etiqueta</th>
					<th v-else-if="(modulo == 'collaborator-coord-classroom')">Aula</th>
					<th v-else>Nombre</th>
					<!-- <th v-if="(modulo == 'Aula')">Nombre corto</th> -->
					<th v-if="(modulo == 'competencia')">Ciclos de evaluación</th>
					<th v-if="(modulo == 'Nivel')">Ciclo curricular</th>
					<th v-if="(modulo == 'Nivel' || modulo == 'Área curricular')">Posición</th>
					<th v-if="(!nostatus && modulo == 'constante')">Posición</th>
					<th v-if="(modulo == 'ayuda')">Tipo</th>
					<th v-if="(modulo == 'institution')">Resolución</th>
					<th v-if="(modulo == 'Curso')">Nombre corto</th>
					<th v-if="(modulo == 'Curso')">Código</th>

					<th v-if="(modulo == 'Aula')">Nom. Corto</th>
					<th v-if="(modulo == 'Aula')">Nom. Secundario</th>
					<th v-if="(modulo == 'Aula')">Tipo</th>
					<th v-if="(modulo == 'Aula')">Cód. Mod.</th>
					<th v-if="(modulo == 'Curso' || modulo == 'ayuda')">Descripción</th>
					<th v-if="(modulo == 'Curso')">Año</th>
					<th v-if="(modulo == 'collaborator-classroom' && !isCoord)">Curso</th>
					<th v-if="(modulo == 'collaborator-classroom')">{{ isCoord ? 'Coord.' : 'Tutor' }}</th>
					<th v-if="(modulo == 'Aula')">Nivel/Grado turno mañana</th>

					<th v-if="(modulo == 'constante' && !nostatus)">Tipo</th>
					<th v-if="(modulo == 'constante')">Valor</th>
					<th v-if="(modulo == 'constante')">Descripción</th>
					<th v-if="(modulo == 'constante')">Modificado por</th>
					<th v-if="(modulo == 'constante')">Modificado el</th>
					<th v-if="(modulo == 'constante' && !nostatus)">Visible</th>

					<th v-if="(modulo == 'traductor')">Nivel</th>
					<th v-if="(modulo == 'traductor')">Key</th>
					<th v-if="(modulo == 'traductor')">Valor</th>

					<th v-if="(modulo == 'mark')">Descripción</th>
					<th v-if="(modulo == 'mark')">URL</th>
					<th v-if="(modulo == 'mark')">Target</th>
					<th v-if="(modulo == 'mark')">Posición</th>

					<template v-if="(modulo == 'holiday')">
						<th>Día</th>
						<th>Mes</th>
						<th>Año</th>
					</template>

					<template v-if="(modulo == 'collaboratorhour')">
						<th>Hora Entrada</th>
						<th>Hora Salida</th>
						<th>Tolerancia Tarde</th>
					</template>

					<template v-if="(modulo == 'collaboratorturn')">
						<th>Horario Lunes</th>
						<th>Horario Martes</th>
						<th>Horario Miércoles</th>
						<th>Horario Jueves</th>
						<th>Horario Viernes</th>
						<th>Horario Sábado</th>
						<th>Horario Domingo</th>
					</template>

					<template v-if="(modulo == 'collaboratorturn-user')">
						<th>ID Entidad</th>
					</template>

					<th v-if="(nostatus == false && modulo != 'constante')">Estado</th>

				</tr>
			</thead>
			<tbody>
				<tr v-for="client in itemsPaginated" :key="client.id">
					<td v-if="(modulo == 'Nivel')" data-label="Nivel padre">
						{{ client.label_parent }}
					</td>
					<td v-if="isRef || modulo == 'Nivel'" data-label="Código">
						<span v-if="client.id_parent"></span>
						{{ client.ref }}
					</td>
					<td v-if="(modulo == 'Curso')" data-label="Nivel/Grado">
						{{ client.label_level }}
					</td>
					<td v-if="(modulo == 'Curso' || modulo == 'competencia')" data-label="Área curricular">
						{{ client.label_area }}
					</td>
					<td v-if="(modulo == 'Aula')" data-label="Código">
						{{ client.ref }}
					</td>
					<td v-if="(modulo == 'modularcode')" data-label="Inst./Sede">
						{{ client.label_institution }}
					</td>
					<td v-if="(modulo == 'modularcode')" data-label="Nivel">
						{{ client.label_level }}
					</td>
					<td data-label="Nombre">
						{{ modulo == 'constante' ? client.name : client.label }}
					</td>
					<!-- <td v-if="(modulo == 'Aula')" data-label="Nombre corto">
                {{ client.label_short }}
              </td> -->
					<td v-if="(modulo == 'ayuda')" data-label="Tipo">
						{{ client.type }}
					</td>
					<td v-if="(modulo == 'competencia')" data-label="Ciclos de evaluación">
						{{ client.ciclos }}
					</td>
					<td v-if="(modulo == 'Nivel')" data-label="Ciclo curricular">
						{{ client.ciclo_curricular }}
					</td>
					<td v-if="(modulo == 'Nivel' || modulo == 'Área curricular')" data-label="Posición">
						{{ client.position }}
					</td>
					<td v-if="(!nostatus && modulo == 'constante')" data-label="Posición">
						{{ client.position }}
					</td>
					<td v-if="(modulo == 'Curso')" data-label="Nombre corto">
						{{ client.label_short }}
					</td>
					<td v-if="(modulo == 'Curso')" data-label="Código">
						{{ client.ref }}
					</td>
					<td v-if="(modulo == 'Curso')" data-label="Descripción">
						{{ client.description }}
					</td>
					<td v-if="(modulo == 'ayuda')" data-label="Descripción">
						<div class="overflow-x-scroll block max-w-[40vh] xl:max-w-[70vh] 2xl:max-w-[90vh] px-4 py-2'">
							{{ client.description }}
						</div>
					</td>
					<td v-if="(modulo == 'institution')" data-label="Resolución">
						{{ client.resolution }}
					</td>
					<td v-if="(modulo == 'Aula')" data-label="Nombre corto">
						{{ client.label_short }}
					</td>
					<td v-if="(modulo == 'Aula')" data-label="Nombre secundario">
						{{ client.secondary_label }}
					</td>
					<td v-if="(modulo == 'Aula')" data-label="Tipo">
						{{ client.type ? 'Teórica' : 'Estándar' }}
					</td>
					<td v-if="(modulo == 'Aula')" data-label="Cod. Mod.">
						{{ client.ref_cm }}
					</td>
					<td v-if="(modulo == 'Curso')" data-label="Año">
						{{ client.anio }}
					</td>
					<td v-if="(modulo == 'collaborator-classroom' && !isCoord)" data-label="Curso">
						{{ client.label_course }}
					</td>
					<td v-if="(modulo == 'collaborator-coord-classroom')" data-label="Aula">
						{{ client.label_aula }}
					</td>
					<td v-if="(modulo == 'Aula')" data-label="Nivel/Grado Turno mañana">
						<div class="inline-flex items-center leading-none text-sm border rounded-md py-1 px-2 dark:text-white border-gray-900 dark:border-slate-100 mr-3 last:mr-0">
							<span>{{ client.label_level }}</span>
						</div>
					</td>

					
					<td v-if="(modulo == 'collaborator-classroom')" :data-label="(isCoord ? 'Coord.' : 'Tutor')">
						<div v-if="client.tutor" class="inline-flex items-center leading-none text-sm border rounded-md py-1 px-2 bg-emerald-500 border-emerald-500 text-white last:mr-0">
							<span>Si</span>
						</div>
						<div v-else class="inline-flex items-center leading-none text-sm border rounded-md py-1 px-2 dark:text-white border-gray-900 dark:border-slate-100 mr-3 last:mr-0">
							<span>No</span>
						</div>
					</td>

					<td v-if="(modulo == 'traductor')" data-label="Nivel">
						{{ client.label_level }}
					</td>
					<td v-if="(modulo == 'traductor')" data-label="Key">
						{{ client.transkey }}
					</td>
					<td v-if="(modulo == 'traductor')" data-label="Value">
						{{ client.transvalue }}
					</td>

					<template v-if="(modulo == 'holiday')">
						<td data-label="Día">
							{{ client.day }}
						</td>
						<td data-label="Mes">
							{{ client.month }}
						</td>
						<td data-label="Año">
							{{ client.year }}
						</td>
					</template>

					<template v-if="(modulo == 'mark')">
						<td data-label="Descripción">
							{{ client.description }}
						</td>
						<td data-label="URL">
							{{ client.url }}
						</td>
						<td data-label="Target">
							<div v-if="client.target" class="inline-flex items-center leading-none text-sm border rounded-md py-1 px-2 bg-emerald-500 border-emerald-500 text-white last:mr-0">
								<span>Si</span>
							</div>
							<div v-else class="inline-flex items-center leading-none text-sm border rounded-md py-1 px-2 dark:text-white border-gray-900 dark:border-slate-100 mr-3 last:mr-0">
								<span>No</span>
							</div>
						</td>
						<td data-label="Posición">
							{{ client.position }}
						</td>
					</template>

					<template v-if="(modulo == 'collaboratorhour')">
						<td data-label="Hora Entrada">
							{{ client.hora_entrada }}
						</td>
						<td data-label="Hora Salida">
							{{ client.hora_salida }}
						</td>
						<td data-label="Tolerancia Tarde">
							{{ client.tolerancia_tarde + ' min.' }}
						</td>
					</template>

					<template v-if="(modulo == 'collaboratorturn')">
						<td data-label="Horario Lunes">
							{{ client.label_monday }}
						</td>
						<td data-label="Horario Martes">
							{{ client.label_tuesday }}
						</td>
						<td data-label="Horario Miércoles">
							{{ client.label_wednesday }}
						</td>
						<td data-label="Horario Jueves">
							{{ client.label_thursday }}
						</td>
						<td data-label="Horario Viernes">
							{{ client.label_friday }}
						</td>
						<td data-label="Horario Sábado">
							{{ client.label_saturday }}
						</td>
						<td data-label="Horario Domingo">
							{{ client.label_sunday }}
						</td>
					</template>

					<template v-if="(modulo == 'collaboratorturn-user')">
						<td data-label="Código Entidad">
							{{ client.pivot.entity }}
						</td>
					</template>

					<!-- Estado -->
					<td v-if="(nostatus == false && modulo != 'constante' && modulo != 'mark')" data-label="Estado" class="lg:w-1 whitespace-nowrap">
						<!-- - LRR <small
                  class="text-gray-500 dark:text-slate-400"
                  :title="client.status"
                  >{{ client.status }}</small
              >-->
						<div v-if="client.status" class="inline-flex items-center leading-none text-sm border rounded-md py-1 px-2 bg-emerald-500 border-emerald-500 text-white last:mr-0">
							<span>Activo</span>
						</div>
						<div v-else class="inline-flex items-center leading-none text-sm border rounded-md py-1 px-2 bg-red-500 border-red-500 text-white last:mr-0">
							<span>Inactivo</span>
						</div>
					</td>
					<td v-if="(nostatus == false && modulo == 'constante')" data-label="tipo">
						<div class="inline-flex items-center leading-none text-sm border rounded-md py-1 px-2 dark:text-white border-gray-900 dark:border-slate-100 mr-3 last:mr-0">
							<span>{{ client.type }}</span>
						</div>
					</td>
					<td v-if="(modulo == 'constante')" data-label="value">
						<div v-if="client.type == 'sino'">
							<div v-if="client.value == '1'" class="inline-flex items-center leading-none text-sm border rounded-md py-1 px-2 bg-emerald-500 border-emerald-500 text-white last:mr-0">
								<span>Si</span>
							</div>
							<div v-else class="inline-flex items-center leading-none text-sm border rounded-md py-1 px-2 dark:text-white border-gray-900 dark:border-slate-100 mr-3 last:mr-0">
								<span>No</span>
							</div>
						</div>
						<div v-else>
							{{ client.value }}
						</div>
					</td>
					<td v-if="(modulo == 'constante')" data-label="Descripción">
						<div class="lg:w-auto !w-[400px]">
							{{ client.note }}
						</div>
					</td>
					<td v-if="(modulo == 'constante')" data-label="Modificado por">
						{{ client.name_user }}
					</td>
					<td v-if="(modulo == 'constante')" data-label="Modificado el">
						{{ (client.updated_at ? formatDate(client.updated_at) : '') }}
					</td>
					<td v-if="(modulo == 'constante' && !nostatus)" data-label="Visible" class="lg:w-1 whitespace-nowrap">
						<!-- - LRR <small
                  class="text-gray-500 dark:text-slate-400"
                  :title="client.status"
                  >{{ client.status }}</small
              >-->
						<div v-if="client.visible" class="inline-flex items-center leading-none text-sm border rounded-md py-1 px-2 bg-emerald-500 border-emerald-500 text-white last:mr-0">
							<span>Visible</span>
						</div>
						<div v-else class="inline-flex items-center leading-none text-sm border rounded-md py-1 px-2 bg-red-500 border-red-500 text-white last:mr-0">
							<span>No visible</span>
						</div>
					</td>

					<!-- Buttons -->
					<td class="before:hidden lg:w-1 whitespace-nowrap">
						<BaseButtons type="justify-start lg:justify-end" no-wrap>

							<!--class="inline-flex justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border cursor-pointer rounded border-yellow-600 dark:border-yellow-500 ring-yellow-300 dark:ring-yellow-700 bg-yellow-600 dark:bg-yellow-500 text-white hover:bg-yellow-700 hover:border-yellow-700 hover:dark:bg-yellow-600 hover:dark:border-yellow-600 p-1 mr-3 last:mr-0 mb-3"
                    -->
							<!--class="inline-flex justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border cursor-pointer rounded border-emerald-600 dark:border-emerald-500 ring-emerald-300 dark:ring-emerald-700 bg-emerald-600 dark:bg-emerald-500 text-white hover:bg-emerald-700 hover:border-emerald-700 hover:dark:bg-emerald-600 hover:dark:border-emerald-600 p-1 mr-3 last:mr-0 mb-3"-->
							<BaseButton v-if="(!noupdate)" color="warning" :icon="mdiPencil" small @click="initModal(client.id, 'actualizar', client)" />

							<template v-if="(nostatus == false && modulo != 'constante' && modulo != 'mark')">
								<BaseButton v-if="client.status" color="danger" :icon="mdiCloseCircle" small @click="initModal(client.id, 'desactivar')" class="inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-red-600 dark:border-red-500 ring-red-300 dark:ring-red-700 bg-red-600 dark:bg-red-500 text-white hover:bg-red-700 hover:border-red-700 hover:dark:bg-red-600 hover:dark:border-red-600 p-1 mr-3 last:mr-0 mb-3" />
								<BaseButton v-else color="success" :icon="mdiCheckCircle" small @click="initModal(client.id, 'activar')" />
							</template>

							<template v-if="modulo == 'constante' && !nostatus">
								<BaseButton v-if="client.visible" color="danger" :icon="mdiCloseCircle" small @click="initModal(client.id, 'desactivar')" class="inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-red-600 dark:border-red-500 ring-red-300 dark:ring-red-700 bg-red-600 dark:bg-red-500 text-white hover:bg-red-700 hover:border-red-700 hover:dark:bg-red-600 hover:dark:border-red-600 p-1 mr-3 last:mr-0 mb-3" />
								<BaseButton v-else color="success" :icon="mdiCheckCircle" small @click="initModal(client.id, 'activar')" />
							</template>


							<BaseButton v-if="deleteable || modulo == 'mark'" color="danger" :icon="mdiTrashCan" small @click="initModal(client.id, 'eliminar', client)" />
						</BaseButtons>
					</td>

				</tr>
			</tbody>
		</table>
		<div class="p-3 lg:px-6 border-t border-gray-100 dark:border-slate-800">
			<BaseLevel>
				<BaseButtons>
					<BaseButton v-for="page in pagesList" :key="page" :active="page === currentPage" :label="page + 1" :color="page === currentPage ? 'lightDark' : 'whiteDark'" small @click="currentPage = page" />
				</BaseButtons>
				<small>Página {{ currentPageHuman }} de {{ numPages }}</small>
			</BaseLevel>
		</div>
	</template>
	<template v-else>
		<CardBoxComponentEmpty />
	</template>
</template>
    